import * as React from 'react';
import { ISvgAtomProps } from './Atoms.interfaces';

const ProductWasUnitPrice: React.FC<ISvgAtomProps> = ({ width = 90, height = 12 }) => {
  return (
    <svg x={0} y={0} width={width} height={height} viewBox={`0 0 ${width} ${height}`}>
      <rect x={0} y={0} width={width} height={height} rx={4} fill="#e9ecef" stroke="#e9ecef" />
      <text x={10} y={height / 2} textAnchor="start" dominantBaseline="middle" fill="#7a7a7a" fontSize={8}>
        Was Unit Price
      </text>
    </svg>
  );
};

export default ProductWasUnitPrice;
